import { render, staticRenderFns } from "./DependencyModal.vue?vue&type=template&id=26eb3745&scoped=true"
import script from "./DependencyModal.vue?vue&type=script&lang=js"
export * from "./DependencyModal.vue?vue&type=script&lang=js"
import style0 from "./DependencyModal.vue?vue&type=style&index=0&id=26eb3745&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26eb3745",
  null
  
)

export default component.exports